<template>
  <div class="position-relative pb-5">
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ this.$store.state.auth }} -->
    <div class="row mb-5">
      <ul class="nav nav-tabs nav-fill">
        <li class="nav-item">
          <button
            type="button"
            :class="tab_switch('owner')"
            @click="tab_switch_action('owner')"
          >
            <i class="bi bi-person-fill me-1"></i>主催者情報
          </button>
        </li>
        <!-- <li class="nav-item" v-if="not_add">
          <button type="button" :class="tab_switch('license')" @click="tab_switch_action('license')" >
            <i class="bi bi-list-check me-1"></i>ライセンス情報
          </button>
        </li>
        <li class="nav-item d-none" v-if="not_add">
          <button type="button" :class="tab_switch('pre_ex')" @click="tab_switch_action('pre_ex')" >
            <i class="bi bi-file-earmark-medical"></i>エントリー履歴
          </button>
        </li> -->
      </ul>
    </div>
    <div :class="'w100 ' + tabDisplay('member')">
      <h5>クラブ員情報</h5>
    </div>
    <div :class="'w100 ' + tabDisplay('license')">
      <h5>申請状況</h5>
      <div class="container">
        {{ dev_msg('未設定') }}
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center align-middle" style="width: 10%">日時</th>
              <th class="text-center align-middle" style="width: 25%">
                申請内容
              </th>
              <th class="text-center align-middle" style="width: 25%">
                処理状況
              </th>
              <th class="text-center align-middle" style="width: 30%">メモ</th>
              <th class="text-center align-middle" style="width: 10%"></th>
            </tr>
          </thead>
        </table>
      </div>
      <h5>取得ライセンス</h5>
      <div class="container">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="">種別</th>
              <th class="">種目</th>
              <th class="">ライセンス</th>
              <th class="">受講日</th>
              <th style="width: 40%">期間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="license in license_filter_sort(1)" :key="license">
              <td>競技ライセンス</td>
              <td>{{ get_list_label(license.event_cd, event_cd_list) }}</td>
              <td>{{ license.print_label }}</td>
              <td>2024-03-31</td>
              <td>
                <div class="input-group">
                  <input type="date" value="" class="form-control" />
                  <span class="input-group-text">〜</span>
                  <input type="date" value="" class="form-control" />
                </div>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr v-for="license in license_filter_sort(2)" :key="license">
              <td>競技役員</td>
              <td>{{ get_list_label(license.event_cd, event_cd_list) }}</td>
              <td>{{ license.short_label }}</td>
              <td>2024-03-31</td>
              <td>
                <div class="input-group">
                  <input type="date" value="" class="form-control" />
                  <span class="input-group-text">〜</span>
                  <input type="date" value="" class="form-control" />
                </div>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr v-for="license in license_filter_sort(3)" :key="license">
              <td>講師</td>
              <td>{{ get_list_label(license.event_cd, event_cd_list) }}</td>
              <td>{{ license.short_label }}</td>
              <td>2024-03-31</td>
              <td>
                <div class="input-group">
                  <input type="date" value="" class="form-control" />
                  <span class="input-group-text">〜</span>
                  <input type="date" value="" class="form-control" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h5>取得ライセンス(期間)</h5>
      <div class="container">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th
                class="text-center align-middle"
                style="width: 10%"
                rowspan="2"
              >
                年度
              </th>
              <th
                class="text-center align-middle"
                style="width: 40%"
                colspan="2"
              >
                ライセンス 資格
              </th>
              <th
                class="text-center align-middle"
                style="width: 25%"
                rowspan="2"
              >
                競技役員 資格
              </th>
              <th
                class="text-center align-middle"
                style="width: 25%"
                rowspan="2"
              >
                講師 資格
              </th>
            </tr>
            <tr>
              <th class="text-center">4月〜12月</th>
              <th class="text-center">1月〜3月</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="year in license_year_list" :key="year">
              <td class="text-center">{{ year.key }}</td>
              <td
                v-if="
                  chk_owner_license_filter_year_class_only_term(
                    year.key,
                    1,
                    100
                  )
                "
                colspan="2"
              >
                <span
                  class="me-2"
                  v-for="license in get_owner_license_filter_year_class_terms(
                    year.key,
                    1,
                    [100]
                  )"
                  :key="license"
                >
                  {{
                    get_list_param('license', license.license_cd, 'short_label')
                  }}
                </span>
              </td>
              <td v-else>
                <span
                  class="me-2"
                  v-for="license in get_owner_license_filter_year_class_terms(
                    year.key,
                    1,
                    [200, 100]
                  )"
                  :key="license"
                >
                  {{
                    get_list_param('license', license.license_cd, 'short_label')
                  }}
                </span>
              </td>
              <td
                v-if="
                  !chk_owner_license_filter_year_class_only_term(
                    year.key,
                    1,
                    100
                  )
                "
              >
                <span
                  class="me-2"
                  v-for="license in get_owner_license_filter_year_class_terms(
                    year.key,
                    1,
                    [300, 100]
                  )"
                  :key="license"
                >
                  {{
                    get_list_param('license', license.license_cd, 'short_label')
                  }}
                </span>
              </td>
              <td>
                <span
                  class="me-2"
                  v-for="license in get_owner_license_filter_year_class_terms(
                    year.key,
                    2,
                    [100, 200, 300]
                  )"
                  :key="license"
                >
                  {{
                    get_list_param('license', license.license_cd, 'short_label')
                  }}
                </span>
              </td>
              <td>
                <span
                  class="me-2"
                  v-for="license in get_owner_license_filter_year_class_terms(
                    year.key,
                    3,
                    [100, 200, 300]
                  )"
                  :key="license"
                >
                  {{
                    get_list_param('license', license.license_cd, 'short_label')
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div :class="'w100 ' + tabDisplay('owner')">
      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">公認情報</p>
        </div>
      </div>
      <div class="container">
        <div class="row mb-3" v-if="false">
          <div class="col-2">
            <p class="text-center py-1 fs-7">年度</p>
          </div>
          <div class="col-3">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                id="last_sports_year"
                placeholder="年度"
                v-model="owner_obj.last_sports_year"
                :disabled="input_readonly"
              />
              <span class="input-group-text">年度</span>
            </div>
          </div>
          <div class="col-2">
            <p class="text-center py-1 fs-7">公認期間</p>
          </div>
          <div class="col-5">
            <div class="input-group">
              <input
                type="date"
                :class="input_class"
                id="last_sports_year"
                placeholder="年度"
                v-model="owner_obj.last_sports_year"
                :disabled="input_readonly"
              />
              <span class="input-group-text">〜</span>
              <input
                type="date"
                :class="input_class"
                id="last_sports_year"
                placeholder="年度"
                v-model="owner_obj.last_sports_year"
                :disabled="input_readonly"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">主催者コード</p>
          </div>
          <div class="col-3">
            <div class="input-group">
              <input
                v-if="change_mode"
                type="text"
                :class="input_class"
                placeholder="主催者コード"
                v-model="owner_obj.owner_no"
                :disabled="input_readonly"
              />
              <input
                v-else
                type="text"
                :class="'form-control'"
                placeholder="主催者コード"
                v-model="owner_obj.owner_no"
              />
            </div>
            <!-- <input
              type="text"
              :class="input_class"
              placeholder="主催者コード"
              v-model="owner_obj.owner_no"
              :disabled="input_readonly"
            /> -->
          </div>
        </div>
        <div class="row mb-1 pb-1 border-bottom">
          <div class="col-2">
            <p class="fs-6 mb-0 pb-0">ログイン情報</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">ログインID</p>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                v-if="change_mode"
                type="text"
                :class="input_class"
                placeholder="ログインID"
                v-model="owner_obj.login_id"
                :disabled="input_readonly"
              />
              <input
                v-else
                type="text"
                :class="chk_input_class('login_id', 'input')"
                placeholder="ログインID"
                v-model="owner_obj.login_id"
              />
            </div>
            <div v-if="chk_error('login_id')" class="text-danger">
              {{ get_error_msg('login_id') }}
            </div>
          </div>
          <div class="col-2">
            <p class="text-center py-1 fs-7">初期パスワード</p>
          </div>
          <div class="col-4" v-if="!not_add">
            <div class="input-group">
              <input
                v-if="change_mode"
                type="text"
                :class="input_class"
                placeholder="初期パス-"
                v-model="owner_obj.default_pass"
                :disabled="input_readonly"
              />
              <input
                v-else
                type="text"
                :class="chk_input_class('login_id', 'input')"
                placeholder="初期パス--"
                v-model="owner_obj.default_pass"
              />
            </div>
          </div>
          <div class="col-4" v-else-if="not_add">
            <div class="input-group">
              <input
                type="text"
                :class="'form-control-plaintext'"
                placeholder="初期パス-"
                v-model="owner_obj.default_pass"
                :disabled="true"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3" v-if="!change_mode && !not_add">
          <div class="col-2">
            <p class="text-center py-1 fs-7">ログインPW</p>
          </div>
          <div :class="pass_chg_sw ? 'col-10' : 'col-4'">
            <div class="input-group">
              <label class="input-group-text" for="PassChgSw">
                <input
                  class="form-check-input mt-0 me-2"
                  id="PassChgSw"
                  type="checkbox"
                  v-model="pass_chg_sw"
                />
                変更
              </label>
              <input
                type="text"
                :class="input_class"
                placeholder="パスワード"
                v-model="login_pass_input"
                :disabled="!pass_chg_sw ? 'disabled' : false"
              />
              <span class="input-group-text" v-if="pass_chg_sw">確認用</span>
              <input
                type="text"
                :class="input_class"
                placeholder="パスワード確認用"
                v-model="pass_chg_confirm"
                v-if="pass_chg_sw"
              />
            </div>
          </div>
        </div>
        <div class="row mb-1 pb-1 border-bottom">
          <div class="col-2">
            <p class="fs-6 mb-0 pb-0">主催者情報</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">主催者名</p>
          </div>
          <div class="col-6">
            <input
              type="text"
              :class="input_class"
              id="Name_1"
              placeholder="主催者名"
              v-model="owner_obj.name_1"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">カナ</p>
          </div>
          <div class="col-6">
            <input
              type="text"
              :class="input_class"
              id="Yomi_1"
              placeholder="セイ"
              v-model="owner_obj.yomi_1"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">代表者/責任者</p>
          </div>
          <div class="col-10">
            <div class="input-group">
              <span class="input-group-text">姓</span>
              <input
                type="text"
                :class="input_class"
                id="Name_2"
                placeholder="姓"
                v-model="owner_obj.name_2"
              />
              <span class="input-group-text">名</span>
              <input
                type="text"
                :class="input_class"
                id="Name_3"
                placeholder="名"
                v-model="owner_obj.name_3"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">カナ</p>
          </div>
          <div class="col-10">
            <div class="input-group">
              <span class="input-group-text">セイ</span>
              <input
                type="text"
                :class="input_class"
                id="Yomi_2"
                placeholder="セイ"
                v-model="owner_obj.yomi_2"
              />
              <span class="input-group-text">メイ</span>
              <input
                type="text"
                :class="input_class"
                id="Yomi_3"
                placeholder="メイ"
                v-model="owner_obj.yomi_3"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">団体/個人</p>
          </div>
          <div class="col-10">
            <input
              v-if="change_mode"
              :value="get_list_label(owner_obj.owner_type, owner_type_list)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="owner_type_list"
              :nullOption="false"
              v-model="owner_obj.owner_type"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">請求書発行</p>
          </div>
          <div class="col-10">
            <input
              v-if="change_mode"
              :value="get_list_label(owner_obj.print_invoice, print_sw)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="print_sw"
              :nullOption="false"
              v-model="owner_obj.print_invoice"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">領収書発行</p>
          </div>
          <div class="col-10">
            <input
              v-if="change_mode"
              :value="get_list_label(owner_obj.print_receipt, print_sw)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="print_sw"
              :nullOption="false"
              v-model="owner_obj.print_receipt"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3 d-none">
          <div class="col-2">
            <p class="text-center py-1 fs-7">写真</p>
          </div>
          <div class="col-3">
            <div class="w-100" v-if="typeof get_assets(100, 0) === 'object'">
              <img :src="(get_assets(100, 0) || {}).path" class="w-100" />
            </div>
          </div>
          <div class="col-6">
            <input
              type="file"
              v-if="!change_mode"
              :class="input_class"
              id="file_up_input_100"
              @change="selectedFile($event, 100)"
            />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">代表者/責任者 MFJ No.</p>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                placeholder="MFJライセンス"
                v-model="owner_obj.license_no"
                :readonly="input_readonly"
                @change="chg_member_from_license_no"
              />
              <button
                type="submit"
                class="btn btn-default btn-outline-secondary"
                @click="search_member_from_license_no()"
              >
                <i class="bi bi-search"></i>
              </button>
            </div>
          </div>
          <div class="col-6">
            <input
              type="text"
              :class="input_class_f"
              placeholder="ライセンス会員名"
              v-model="license_no_member_label"
              :readonly="input_readonly_f"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">主催者資格</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              :value="
                get_list_label(
                  owner_obj.race_owner_type_cd,
                  race_owner_type_cd_list
                )
              "
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="race_owner_type_cd_list"
              :nullOption="false"
              v-model="owner_obj.race_owner_type_cd"
            ></bs-select>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">開催種目</p>
          </div>
          <div class="col-10">
            <div class="row">
              <div
                class="col-3 mb-2"
                v-for="event in event_cd_list"
                :key="event"
              >
                <div
                  class="d-grid"
                  v-if="change_mode && attach_check_event(event.event_cd)"
                >
                  <button
                    type="button"
                    :class="attach_class_event(event.event_cd)"
                    disabled="disabled"
                  >
                    <i :class="attach_class_event_icon(event.event_cd)"></i>
                    {{ event.label }}
                  </button>
                </div>
                <div class="d-grid" v-else-if="!change_mode">
                  <button
                    type="button"
                    :class="attach_class_event(event.event_cd)"
                    @click="attach_event(event.event_cd)"
                  >
                    <i :class="attach_class_event_icon(event.event_cd)"></i>
                    {{ event.label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mb-3" v-if="chk_club_data">
          <div class="col-2">
            <p class="text-center py-1 fs-7">公認クラブ</p>
          </div>
          <div class="col-4">
            <div class="input-group" v-if="!change_mode">
              <input
                type="text"
                :class="input_class"
                placeholder="クラブコード"
                v-model="owner_obj.club_no"
                :readonly="input_readonly"
              />
              <button
                type="submit"
                class="btn btn-default btn-outline-secondary"
                @click="search_club_from_club_no()"
              >
                <i class="bi bi-search"></i>
              </button>
            </div>
            <input
              type="text"
              :class="input_class"
              placeholder="クラブコード"
              v-model="owner_obj.club_no"
              :readonly="input_readonly"
              v-else
            />
          </div>
          <div class="col-6">
            <input
              type="text"
              :class="input_class_f"
              placeholder="公認クラブ名称"
              :value="owner_obj.club_label"
              :readonly="input_readonly_f"
            />
          </div>
        </div>
        <div class="row mb-3" v-if="chk_club_data">
          <div class="col-2">
            <p class="text-center py-1 fs-7">クラブ員数</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              v-model="owner_obj.club_member_num"
              :class="input_class_f"
              :readonly="input_readonly_f"
            />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mb-3" v-if="false">
          <div class="col-2">
            <p class="text-center py-1 fs-7">都道府県</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              :value="get_list_label(owner_obj.pref_cd, pref_cd_list)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="pref_cd_list"
              :nullOption="false"
              v-model="owner_obj.pref_cd"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">地区</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              :value="get_list_label(owner_obj.region_cd, region_cd_list)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="region_cd_list"
              :nullOption="false"
              v-model="owner_obj.region_cd"
            ></bs-select>
          </div>
        </div>
      </div>
      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">住所</p>
        </div>
      </div>
      <div
        class="container pb-2 mb-2 border-bottom"
        v-for="(prof, index) in owner_obj.profile"
        :key="prof"
      >
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">郵便番号</p>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                placeholder="郵便番号"
                v-model="prof.postal_cd"
                :readonly="input_readonly"
              />
              <button
                v-if="!change_mode"
                type="button"
                class="btn btn-light btn-outline-secondary"
                @click="get_address(prof.postal_cd, index, 'profile')"
              >
                郵便番号検索
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">都道府県</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              type="text"
              :class="input_class"
              :readonly="input_readonly"
              :value="get_pref_label(prof.pref_cd)"
            />
            <bs-select
              v-else
              :options="pref_list"
              :nullOption="true"
              id="SexType"
              v-model="prof.pref_cd"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">市区町村・番地</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="市区町村・番地"
              v-model="prof.address_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">建物名・室号</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="建物名・室号"
              v-model="prof.address_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号1</p>
          </div>
          <div class="col-5">
            <!-- <div class="input-group">
                <input type="text" v-model="prof.tel_1[0]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_1[1]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_1[2]" :class="input_class" :readonly="input_readonly">
            </div> -->
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号1"
              v-model="prof.tel_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号2</p>
          </div>
          <div class="col-5">
            <!-- <div class="input-group">
                <input type="text" v-model="prof.tel_2[0]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_2[1]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_2[2]" :class="input_class" :readonly="input_readonly">
            </div> -->
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号2"
              v-model="prof.tel_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールアドレス1</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="メールアドレス1"
              v-model="prof.mail_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールアドレス2</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="メールアドレス2"
              v-model="prof.mail_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">URL</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="URL1"
              v-model="prof.website_url_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
      </div>
      <div class="row mb-1 pb-1 border-bottom" v-if="false">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">連絡先</p>
        </div>
      </div>
      <div
        class="container pb-2 mb-2 border-bottom d-none"
        v-for="(addresss, index) in owner_obj.owner_address"
        :key="addresss"
      >
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">郵便番号</p>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                placeholder="郵便番号"
                v-model="addresss.postal_cd"
                :readonly="input_readonly"
              />
              <button
                v-if="!change_mode"
                type="button"
                class="btn btn-light btn-outline-secondary"
                @click="get_address(addresss.postal_cd, index, 'address')"
              >
                郵便番号検索
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">都道府県</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              type="text"
              :class="input_class"
              :readonly="input_readonly"
              :value="get_pref_label(addresss.pref_cd)"
            />
            <bs-select
              v-else
              :options="pref_list"
              :nullOption="true"
              id="SexType"
              v-model="addresss.pref_cd"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">市区町村・番地</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="市区町村・番地"
              v-model="addresss.address_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">建物名・室号</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="建物名・室号"
              v-model="addresss.address_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号1</p>
          </div>
          <div class="col-5">
            <!-- <div class="input-group">
                <input type="text" v-model="addresss.tel_1[0]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="addresss.tel_1[1]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="addresss.tel_1[2]" :class="input_class" :readonly="input_readonly">
            </div> -->
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号1"
              v-model="addresss.tel_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号2</p>
          </div>
          <div class="col-5">
            <!-- <div class="input-group">
                <input type="text" v-model="addresss.tel_2[0]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="addresss.tel_2[1]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="addresss.tel_2[2]" :class="input_class" :readonly="input_readonly">
            </div> -->
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号2"
              v-model="addresss.tel_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
      </div>
      <div class="container mb-4" v-if="false">
        <dvi class="row" v-if="!change_mode">
          <div class="col text-end">
            <button
              type="button"
              @click="add_address()"
              class="btn btn-sm btn-light btn-outline-secondary"
            >
              <i class="bi bi-plus"></i>&nbsp;連絡先追加
            </button>
          </div>
        </dvi>
      </div>

      <!-- {{district_cd_list}}<hr> -->
      <!-- {{ owner_obj.event_relation }} -->

      <div class="row mb-3 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">その他</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">主催権不備</p>
        </div>
        <div class="col-2">
          <input
            v-if="change_mode"
            :value="
              get_list_label(
                owner_obj.complete_type == '' ? 0 : owner_obj.complete_type,
                complete_type_list
              )
            "
            :class="input_class"
            :readonly="input_readonly"
          />
          <bs-select
            v-else
            :options="complete_type_list"
            :nullOption="false"
            v-model="owner_obj.complete_type"
          ></bs-select>
        </div>
        <div class="col-8">
          <input
            type="text"
            :class="input_class"
            placeholder="不備事由"
            v-model="owner_obj.complete_type_note"
            :readonly="input_readonly"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">備考</p>
        </div>
        <div class="col-10">
          <p class="" v-if="change_mode" style="white-space: pre">
            {{ owner_obj.note }}
          </p>
          <textarea
            class="form-control"
            v-else
            v-model="owner_obj.note"
          ></textarea>
        </div>
      </div>
      <div class="row mb-3" v-if="false">
        <div class="col-2">
          <p class="text-center py-1 fs-7">対応メモ</p>
          <div v-if="!change_mode">
            <button
              type="button"
              class="btn btn-light btn-outline-secondary"
              @click="add_note"
            >
              <i class="bi bi-plus"></i>
            </button>
          </div>
        </div>
        <div class="col-10">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20%">日時</th>
                <th style="width: auto">メモ</th>
                <th style="width: 20%">記入者</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="note in owner_obj.owner_note" :key="note">
                <td>
                  <input
                    type="date"
                    v-model="note.set_date"
                    class="form-control form-control-sm"
                    :disabled="note.id > 0 ? 'disabled' : false"
                  />
                </td>
                <td>
                  <textarea
                    class="form-control form-control-sm"
                    v-model="note.body"
                    :disabled="note.id > 0 ? 'disabled' : false"
                  ></textarea>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="note.manage_label"
                    class="form-control form-control-sm"
                    disabled="disabled"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="mb-5"></div>
    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
    >
      <div class="row">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            v-if="change_mode"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
          <button
            type="submit"
            v-else-if="not_add"
            @click="toggle_change_mode"
            class="btn btn-light btn-outline-secondary"
          >
            照会画面へ戻る
          </button>
          <button
            type="submit"
            v-else-if="!not_add"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/owner/data')"
        >
          <bs-button
            v-if="change_mode"
            :btnClass="'btn-primary'"
            @to_click_event="toggle_change_mode"
            >編集へ</bs-button
          >
          <bs-button
            v-else
            :btnClass="'btn-primary'"
            @to_click_event="update_owner"
            >{{ btnLabel }}</bs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.fs-6 {
  font-size: 1.15rem !important;
}
.fs-7 {
  font-size: 1rem !important;
}
.fs-8 {
  font-size: 0.9rem !important;
}
.input-group > .form-control-plaintext {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  padding: 0.375rem;
  border-bottom: solid 1px #999;
}
.form-control-plaintext {
  border-bottom: solid 1px #999;
}
</style>
<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'
import common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'

export default {
  name: 'OwnerDetailView',
  data: function () {
    return {
      superuser_sw: this.$store.state.auth.userId == 1 ? false : false,
      targetid: this.$route.params.id,
      change_mode: true,
      change_mode_0: true,
      fromParentTitle: '',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      owner_obj: {},
      owner_error_obj: {},
      region_obj: [],
      pref_obj: [],
      district_obj: [],
      request_type_cd_obj: [],
      identify_type_cd_obj: [],
      exclude_cd_obj: [],
      dead_or_live_obj: [],
      owner_assets_cd_obj: [],
      owner_document_cd_obj: [],
      continue_app_type_obj: [],
      continue_data_save_type_obj: [],
      affiliation_type_obj: [],
      belong_owner_status_obj: [],
      insurance_type_obj: [],

      race_owner_type_cd_obj: [],
      race_owner_type_grade_obj: [],
      complete_type_obj: [],

      default_pass_random: this.getRandomString(8),

      license_type_obj: [],
      license_class_obj: [],
      license_category_obj: [],
      license_event_cd_obj: [],
      event_cd_obj: [],
      license_cd_obj: [],
      personal_type_obj: [],
      circuit_obj: [],
      tab_active: 'owner',
      pass_chg_sw: false,
      login_pass_input: '',
      pass_chg_confirm: '',
      owner_type_list: [
        {
          key: 0,
          label: '個人'
        },
        {
          key: 1,
          label: '団体'
        }
      ],
      print_sw: [
        {
          key: 0,
          label: '不要'
        },
        {
          key: 1,
          label: '要'
        }
      ],
      // subsub_category_obj: [],
      // require_list: config.REQUIRE_TYPE_LIST,
      profile_column: {
        id: 0,
        postal_cd: '',
        pref_cd: '',
        address_1: '',
        address_2: '',
        address_3: '',
        tel_1: '',
        tel_2: '',
        fax_1: ['', '', ''],
        fax_2: ['', '', ''],
        mail_1: '',
        mail_2: '',
        mail_flg: '',
        website_url_1: '',
        website_url_2: ''
      },
      insurance_column: {
        id: 0,
        insurance_type: '',
        sports_year: '',
        start_date: '',
        end_date: ''
      },
      circuit_license_column: {
        id: 0,
        circuit_id: '',
        circuit_license_no: ''
      },
      belong_owner_column: {
        id: 0,
        group_id: ''
      },
      system_exclude_column: {
        id: 0,
        exclude_cd: '',
        start_date: '',
        start_date_date: '',
        end_date: '',
        end_date_date: '',
        note: '',
        manage_id: this.$store.state.auth.userId,
        manage_label: this.$store.state.auth.label
      },
      owner_parent_column: {
        id: 0,
        license_no: '',
        name_1: '',
        name_2: '',
        name_3: '',
        yomi_1: '',
        yomi_2: '',
        yomi_3: '',
        birth_date: '',
        sex_type: '',
        identify_type: '',
        identify_manage_id: '',
        identify_date: '',
        application_date: '',
        permission_date: '',
        application_date_date: '',
        permission_date_date: '',
        identify_sw: false,
        identify_manage_label: '',
        permission_manage_id: '',
        permission_manage_label: '',
        permission_manage_sw: false
      },
      owner_address_column: {
        id: 0,
        name_1: '',
        yomi_1: '',
        postal_cd: '',
        pref_cd: '',
        address_1: '',
        address_2: '',
        address_3: '',
        tel_1: '',
        tel_2: '',
        fax_1: ['', '', ''],
        fax_2: ['', '', '']
      },
      owner_note_column: {
        id: 0,
        manage_id: '',
        manage_label: '',
        set_date: '',
        body: ''
      },
      owner_assets_column: {
        id: 0,
        type: '',
        path: ''
      },
      owner_license_column: {
        id: 0,
        license_cd: '',
        license_year: '',
        license_to_id: '',
        issue_date: ''
      },
      event_relation_column: {
        id: 0,
        o_id: this.$route.params.id,
        event_id: 0,
        event_cd: ''
      },
      oParam: [
        'profile',
        // 'insurance',
        // 'circuit_license',
        'belong_owner',
        'system_exclude',
        // 'owner_parent',
        'event_relation'
        // 'owner_note',
        // 'owner_assets',
        // 'owner_license'
      ],
      license_no_member_label: '',
      term_year_obj: [],
      default_owner_no: ''
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert,
    BsButton
  },
  methods: {
    async chg_member_from_license_no() {
      if (this.owner_obj?.license_no?.length <= 0) {
        this.license_no_member_label = ''
      }
    },
    async search_member_from_license_no() {
      if (!this.owner_obj.license_no) {
        alert('ライセンスNoを入力してください')
      } else {
        await this.loadMemberList()
      }
    },
    async search_club_from_club_no() {
      if (!this.owner_obj.club_no) {
        alert('クラブコードを入力してください')
      } else {
        await this.loadClubList()
      }
    },
    async loadMemberList() {
      const params = {}
      params['stat'] = [1]
      params['license_no'] = this.owner_obj.license_no
      params['pagegroup'] = 'mfj_member_data.id'

      await this.basicPosts_S(
        config.BASE_API_URL + '/member/number_search',
        params
      )
        .then(async response => {
          console.log('loadMemberList response', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          // this.owner_obj.club_id = (tmp_obj || {}).id ? tmp_obj.id : 0
          let tmplabel = (tmp_obj || {}).name_1 ? tmp_obj.name_1 : ''
          tmplabel += (tmp_obj || {}).name_2 ? tmp_obj.name_2 : ''
          this.license_no_member_label = tmplabel
        })
        .catch(async err => {
          console.log(err)
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadClubList() {
      const params = {}
      params['stat'] = [1]
      params['club_no'] = this.owner_obj.club_no
      params['pagegroup'] = 'mfj_club_data.id'

      await this.basicPosts_S(config.BASE_API_URL + '/club/lists', params)
        .then(async response => {
          console.log('loadClubList response', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          this.owner_obj.club_id = (tmp_obj || {}).id ? tmp_obj.id : 0
          this.owner_obj.club_label = (tmp_obj || {}).name_1
            ? tmp_obj.name_1
            : ''
        })
        .catch(async err => {
          console.log(err)
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadTermYear() {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/term_year/lists', params)
        .then(async response => {
          console.log('loadTermYear response', response)
          this.term_year_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.term_year_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async attach_event(key) {
      const tmps =
        typeof this.owner_obj?.event_relation === 'object'
          ? [...this.owner_obj?.event_relation]
          : []
      if (this.attach_check_event(key)) {
        // const up_rel =
        this.owner_obj.event_relation = tmps.filter(tmp => tmp.event_cd != key)
      } else {
        const form = { ...this.event_relation_column }
        form.event_cd = key
        form.event_id =
          typeof this.event_cd_obj === 'object' &&
          this.event_cd_obj.find(obj => obj.event_cd == key)
            ? this.event_cd_obj.find(obj => obj.event_cd == key).id
            : 0
        if (!this.not_add) {
          form.event_year = common.getNowYear()
        }
        tmps.push(form)
        this.owner_obj.event_relation = tmps
      }
    },
    async selectedFile(e, type_cd) {
      e.preventDefault()
      const files = [...e.target.files]
      // let ups = [];
      files.forEach(async file => {
        const form = new FormData()
        form.append('file', file)
        await this.basicPosts_R(
          config.BASE_API_URL + '/upload/owner_assets',
          form
        )
          .then(res => {
            console.log(res)
            if (res && res.status == 200) {
              const asset_tmp = {
                id: 0,
                stat: 1,
                m_id: 0,
                type: 0,
                path: ''
              }
              const tmps =
                typeof this.owner_obj.owner_assets === 'object'
                  ? [...this.owner_obj.owner_assets]
                  : []
              const asset = tmps.find(tmp => tmp.type == type_cd)
                ? tmps.find(tmp => tmp.type == type_cd)
                : asset_tmp
              asset.m_id = this.not_add ? this.targetid : 0
              asset.type = type_cd
              asset.path = res.data.body.file_path
                ? res.data.body.file_path
                : ''

              if (tmps.find(tmp => tmp.id == asset.id)) {
                const fIndex = tmps.findIndex(tmp => tmp.id == asset.id)
                tmps[fIndex] = asset
                this.owner_obj.owner_assets = tmps
              } else {
                this.owner_obj.owner_assets = [asset].concat(tmps)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            document.getElementById('file_up_input_' + type_cd).value = ''
          })
      })
    },
    async add_circuit_license() {
      const tmps = { ...this.circuit_license_column }
      const circuit_license =
        typeof this.owner_obj.circuit_license === 'object'
          ? this.owner_obj.circuit_license
          : []
      circuit_license.push(tmps)
      this.owner_obj.circuit_license = circuit_license
    },
    async add_belong_owner() {
      const tmps = { ...this.belong_owner_column }
      const belong_owner =
        typeof this.owner_obj.belong_owner === 'object'
          ? this.owner_obj.belong_owner
          : []
      belong_owner.push(tmps)
      this.owner_obj.belong_owner = belong_owner
    },
    async add_system_exclude() {
      const tmps = { ...this.system_exclude_column }
      const system_exclude =
        typeof this.owner_obj.system_exclude === 'object'
          ? this.owner_obj.system_exclude
          : []
      system_exclude.push(tmps)
      this.owner_obj.system_exclude = system_exclude
    },
    async del_system_exclude(index) {
      const system_exclude =
        typeof this.owner_obj.system_exclude === 'object'
          ? this.owner_obj.system_exclude
          : []
      system_exclude.splice(index, 1)
      this.owner_obj.system_exclude = system_exclude
    },
    async add_note() {
      const tmps = { ...this.owner_note_column }
      tmps.set_date = common.getToday()
      tmps.manage_id = this.$store.state.auth.userId
      tmps.manage_label = this.$store.state.auth.label
      const notes =
        typeof this.owner_obj.owner_note === 'object'
          ? this.owner_obj.owner_note
          : []
      notes.push(tmps)
      this.owner_obj.owner_note = notes
    },
    async add_address() {
      const tmps = { ...this.owner_address_column }
      const address =
        typeof this.owner_obj.owner_address === 'object'
          ? this.owner_obj.owner_address
          : []
      address.push(tmps)
      this.owner_obj.owner_address = address
    },
    async set_owner_identify() {
      this.owner_obj.identify_manage_id = this.$store.state.auth.userId
      this.owner_obj.identify_date_date = common.getToday()
      this.owner_obj.identify_manage_label = this.$store.state.auth.label
    },
    async clear_owner_identify() {
      this.owner_obj.identify_manage_id = 0
      this.owner_obj.identify_date_date = ''
      this.owner_obj.identify_manage_label = ''
    },
    async set_owner_permission() {
      this.owner_obj.permission_manage_id = this.$store.state.auth.userId
      this.owner_obj.permission_date_date = common.getToday()
      this.owner_obj.permission_manage_label = this.$store.state.auth.label
    },
    async clear_owner_permission() {
      this.owner_obj.permission_manage_id = 0
      this.owner_obj.permission_date_date = ''
      this.owner_obj.permission_manage_label = ''
    },
    async set_parent_identify(index) {
      this.owner_obj.owner_parent[index].identify_manage_id =
        this.$store.state.auth.userId
      this.owner_obj.owner_parent[index].identify_date_date = common.getToday()
      this.owner_obj.owner_parent[index].identify_manage_label =
        this.$store.state.auth.label
    },
    async clear_parent_identify(index) {
      this.owner_obj.owner_parent[index].identify_manage_id = 0
      this.owner_obj.owner_parent[index].identify_date_date = ''
      this.owner_obj.owner_parent[index].identify_manage_label = ''
    },
    async set_parent_permission(index) {
      this.owner_obj.owner_parent[index].permission_manage_id =
        this.$store.state.auth.userId
      this.owner_obj.owner_parent[index].permission_date_date =
        common.getToday()
      this.owner_obj.owner_parent[index].permission_manage_label =
        this.$store.state.auth.label
    },
    async clear_parent_permission(index) {
      this.owner_obj.owner_parent[index].permission_manage_id = 0
      this.owner_obj.owner_parent[index].permission_date_date = ''
      this.owner_obj.owner_parent[index].permission_manage_label = ''
    },
    delPreferredData(target) {
      const tmps = { ...this.owner_obj }
      if (
        typeof tmps.preferred_date_data === 'object' &&
        typeof tmps.preferred_date_data[target] === 'object'
      ) {
        tmps.preferred_date_data.splice(target, 1)
      }
      this.owner_obj = tmps
    },
    addPreferredData() {
      const tmps = { ...this.owner_obj }
      tmps.preferred_date_data.push(this.preferred_date_column)
      this.owner_obj = tmps
    },
    delStaffRelation(target) {
      const tmps = { ...this.owner_obj }
      if (
        typeof tmps.staff_relation_data === 'object' &&
        typeof tmps.staff_relation_data[target] === 'object'
      ) {
        tmps.staff_relation_data.splice(target, 1)
      }
      this.owner_obj = tmps
    },
    addStaffRelation() {
      const tmps = { ...this.owner_obj }
      tmps.staff_relation_data.push(this.staff_relation_column)
      this.owner_obj = tmps
    },
    async loadSexType() {
      // console.log('tag');
      return this.$store
        .dispatch('fetchBasicLists', { data: {}, target: 'sex_type' })
        .catch(err => Promise.reject(err))
        .then(response => {
          console.log('loadSexType', response)
        })
        .finally(() => {})
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async response => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseCdObj', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadDistrictList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_district/lists',
        params
      )
        .then(async response => {
          console.log('loadPrefList response', response)
          this.district_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.district_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadCircuitList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/circuit/lists', params)
        .then(async response => {
          console.log('loadCircuitList response', response)
          this.circuit_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.circuit_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceOwnerTypeCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_owner_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceOwnerTypeCdList response', response)
          this.race_owner_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.race_owner_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadOwnerObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(config.BASE_API_URL + '/owner/lists', params)
        .then(async response => {
          console.log('loadOwnerObj', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}

          if (typeof tmp_obj === 'object') {
            tmp_obj.live_flg_now = tmp_obj.live_flg ? tmp_obj.live_flg : 'live'
            // this.owner_error_obj = {...tmp_obj}.map(obj => {
            //   obj = (typeof obj === 'object')? []: false;
            //   return obj;
            // })
            const tmps = {}
            Object.keys(tmp_obj).forEach(tmp_key => {
              tmps[tmp_key] = typeof tmp_obj[tmp_key] === 'object' ? [] : false
            })
            this.owner_error_obj = tmps

            this.oParam.forEach(param => {
              const param_key = param + '_column'
              if (
                typeof tmp_obj[param] !== 'object' ||
                tmp_obj[param] === false
              ) {
                tmp_obj[param] = []
              }
              if (
                // typeof tmp_obj[param] !== 'object'
                // ||
                typeof tmp_obj[param] === 'object' &&
                tmp_obj[param].length <= 0
              ) {
                // 保険
                // 所属クラブ
                // サーキットライセンス
                // システム設定
                // 対応メモ

                if (
                  [
                    // 'insurance_column',
                    // 'circuit_license_column',
                    'belong_owner_column',
                    'system_exclude_column',
                    'owner_address_column',
                    'owner_note_column',
                    'event_relation_column'
                  ].includes(param_key) === false
                )
                  tmp_obj[param].push({ ...this[param_key] })
                // this.owner_error_obj[param].push({...this[param_key]}.map(obj => {
                //   obj = false;
                //   return obj;
                // }));
              } else if (param == 'profile') {
                const profile_tmp = tmp_obj[param].map(tmp => {
                  // tel_1 と tel_2 が既に文字列の場合は変更しない
                  if (typeof tmp.tel_1 === 'string') {
                    tmp.tel_1 = tmp.tel_1.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.tel_1)) {
                    tmp.tel_1 = tmp.tel_1.join('-') // 配列の場合、文字列に変換
                  }

                  if (typeof tmp.tel_2 === 'string') {
                    tmp.tel_2 = tmp.tel_2.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.tel_2)) {
                    tmp.tel_2 = tmp.tel_2.join('-') // 配列の場合、文字列に変換
                  }

                  if (typeof tmp.fax_1 === 'string') {
                    tmp.fax_1 = tmp.fax_1.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.tel_1)) {
                    tmp.fax_1 = tmp.fax_1.join('-') // 配列の場合、文字列に変換
                  }

                  if (typeof tmp.fax_2 === 'string') {
                    tmp.fax_2 = tmp.fax_2.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.fax_2)) {
                    tmp.fax_2 = tmp.fax_2.join('-') // 配列の場合、文字列に変換
                  }
                  return tmp
                })

                tmp_obj[param] = profile_tmp
              }
            })
          }
          // 上書き
          this.owner_obj = tmp_obj
          if (tmp_obj.license_no) {
            await this.loadMemberList()
          }
        })
        .catch(async err => {
          console.log(err)
          this.owner_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async toggle_change_mode() {
      if (this.change_mode) {
        this.change_mode = false
      } else {
        this.change_mode = true
      }
    },
    async update_owner() {
      const params = this.owner_obj
      if (this.pass_chg_sw && this.pass_chg_confirm != this.login_pass_input) {
        alert('パスワードが一致しません')
        return true
      } else if (this.pass_chg_sw && this.pass_chg_confirm == '') {
        alert('パスワードを入力して下さい')
        return true
      } else if (
        this.pass_chg_sw &&
        this.pass_chg_confirm == this.login_pass_input
      ) {
        params.login_pass = this.login_pass_input
      }
      if (!this.pass_chg_sw) {
        delete params['login_pass']
      }

      const profs = (params || {}).profile
      if (typeof profs === 'object') {
        params.profile = profs.map(prof => {
          // tel_1 と tel_2 が既に文字列の場合は変更しない
          if (Array.isArray(prof.tel_1)) {
            prof.tel_1 = prof.tel_1.join('-')
          }
          if (Array.isArray(prof.tel_2)) {
            prof.tel_2 = prof.tel_2.join('-')
          }
          if (Array.isArray(prof.fax_1)) {
            prof.fax_1 = prof.fax_1.join('-')
          }
          if (Array.isArray(prof.fax_2)) {
            prof.fax_2 = prof.fax_2.join('-')
          }
          return prof
        })
      }

      await this.update(params)
    },
    async update(params) {
      console.log('component methods', this.owner_obj)

      const post_url = this.not_add
        ? config.BASE_API_URL + '/owner/edit/' + this.targetid
        : config.BASE_API_URL + '/owner/add'

      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update owner response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.owner_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.owner_error_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadOwnerObj()
          this.$forceUpdate()
          alert(this.alertMessage)
        })
    },
    back() {
      this.$router.go(-1)
    },
    tab_switch_action(tab) {
      this.tab_active = tab
    },
    async get_address(postal_cd, index, type) {
      const type_data =
        type == 'profile'
          ? this.owner_obj.profile[index]
          : this.owner_obj.owner_address[index]
      await this.basicGets_O(
        'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + postal_cd
      )
        .then(res => {
          if (
            typeof res === 'object' &&
            typeof res.status === 'number' &&
            res.status == 200 &&
            typeof res.data === 'object' &&
            typeof res.data.results === 'object' &&
            typeof res.data.results[0] === 'object'
          ) {
            type_data.pref_cd =
              parseInt(res.data.results[0].prefcode) < 10
                ? '0' + res.data.results[0].prefcode
                : res.data.results[0].prefcode
            type_data.address_1 =
              res.data.results[0].address2 + res.data.results[0].address3
            type_data.address_2 = ''
            if (type == 'profile') {
              this.owner_obj.profile[index] = type_data
            } else {
              this.owner_obj.owner_address[index] = type_data
            }
          } else {
            alert('住所データがありません')
          }
        })
        .catch(error => {
          console.log(error)
          alert('住所データがありません.')
        })
        .finally(() => {
          this.$forceUpdate()
        })
    },
    async loadNextOwnerNo() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/owner/get_next_owner_no',
        params
      )
        .then(async response => {
          console.log('loadNextOwnerNo response', response)
          this.default_owner_no =
            response.data && response.data.body && response.data.body
              ? response.data.body
              : ''
        })
        .catch(async err => {
          console.log(err)
          this.default_owner_no = ''
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  },
  computed: {
    get_term_year: function () {
      return typeof this.term_year_obj === 'object' &&
        typeof this.term_year_obj[0] === 'object' &&
        this.term_year_obj[0]['label']
        ? parseInt(this.term_year_obj[0]['label'])
        : parseInt(common.getNowYear())
    },
    ...mapState({
      sex_type_list: state => state.apidata.sex_type
    }),
    chk_club_data: function () {
      if (this.owner_obj?.race_owner_type_cd == 8) {
        return true
      }
      return false
    },
    attach_check_event: function () {
      const target_ary = (this.owner_obj || {}).event_relation
      return function (key) {
        // console.log('attach_check tmps', tmps);
        if (
          typeof target_ary === 'object' &&
          target_ary.find(tmp => tmp.event_cd == key)
        ) {
          return true
        } else {
          return false
        }
      }
    },
    attach_class_event: function () {
      const chk_comp = this.attach_check_event
      return function (key) {
        const base_label = 'btn '
        if (chk_comp(key)) {
          return base_label + ' btn-warning'
        } else {
          return base_label + ' btn-light btn-outline-secondary'
        }
      }
    },
    attach_class_event_icon: function () {
      const chk_comp = this.attach_check_event
      return function (key) {
        if (chk_comp(key)) {
          return 'bi-check-square me-2'
        } else {
          return ' bi-square me-2'
        }
      }
    },
    get_wareki: function () {
      const regex1 = /^[0-9]{4}[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12][0-9]|3[01])/

      return function (birth_date) {
        if (regex1.test(birth_date)) {
          console.log('get_wareki', regex1.test(birth_date), birth_date)
          return new Date(birth_date).toLocaleDateString(
            'ja-JP-u-ca-japanese',
            {
              dateStyle: 'long'
            }
          )
        }
        return birth_date
      }
    },
    chk_parent_form: function () {
      if (
        this.calc_age <= 18 &&
        typeof this.owner_obj === 'object' &&
        typeof this.owner_obj.owner_license === 'object'
        // && typeof this.owner_obj.owner_license.find()
      ) {
        return true
      }
      return false
    },
    input_class: function () {
      if (this.change_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly: function () {
      if (this.change_mode) {
        return true
      } else {
        return false
      }
    },
    input_class_0: function () {
      if (this.change_mode_0) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly_0: function () {
      if (this.change_mode_0) {
        return true
      } else {
        return false
      }
    },
    input_class_f: function () {
      if (this.change_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control-plaintext'
      }
    },
    input_readonly_f: function () {
      if (this.change_mode) {
        return true
      } else {
        return true
      }
    },
    get_list_label: function () {
      return function (key, lists) {
        if (
          typeof lists === 'object' &&
          typeof lists.find(list => list.key == key) === 'object'
        ) {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    get_pref_label: function () {
      const pref_list = this.pref_list
      return function (key) {
        if (typeof pref_list.find(pref => pref.key == key) === 'object') {
          return pref_list.find(pref => pref.key == key).label
        }
        return key
      }
    },
    get_request_cd_label: function () {
      const lists = this.request_type_list
      return function (key) {
        if (typeof lists.find(list => list.key == key) === 'object') {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    get_sex_type_label: function () {
      const sex_type_list = this.sex_type_list
      return function (key) {
        if (
          typeof sex_type_list.find(sex_type => sex_type.key == key) ===
          'object'
        ) {
          return sex_type_list.find(sex_type => sex_type.key == key).label
        }
        return key
      }
    },
    get_assets: function () {
      const owner_obj = this.owner_obj
      return function (type_cd, sort_key) {
        if (
          typeof owner_obj === 'object' &&
          typeof owner_obj.owner_assets === 'object' &&
          owner_obj.owner_assets.find(asset => asset.type == type_cd) !==
            false &&
          typeof owner_obj.owner_assets.filter(
            asset => asset.type == type_cd
          ) === 'object' &&
          typeof owner_obj.owner_assets.filter(asset => asset.type == type_cd)[
            sort_key
          ] === 'object'
        ) {
          return owner_obj.owner_assets.filter(asset => asset.type == type_cd)[
            sort_key
          ]
        }
        return {}
      }
    },
    chk_input_class: function () {
      const chk_func = this.chk_error
      return function (error_key, form) {
        if (form == 'input') {
          if (chk_func(error_key)) {
            return 'form-control is-invalid'
          } else {
            return 'form-control'
          }
        }
        return 'form-control'
      }
    },
    get_error: function () {
      const error_obj = this.owner_error_obj
      return function (error_key) {
        const params =
          error_key.indexOf('.') > -1
            ? error_key.split('.')
            : [].concat(error_key)
        if (typeof error_obj === 'object' && typeof params === 'object') {
          if (
            params.length == 2 &&
            typeof error_obj[params[0]] === 'object' &&
            typeof error_obj[params[0]][params[1]] === 'string'
          ) {
            return error_obj[params[0]][params[1]]
          } else if (
            params.length == 1 &&
            typeof error_obj[params[0]] === 'string'
          ) {
            return error_obj[params[0]]
          }
        }
        return false
      }
    },
    chk_error: function () {
      const get_func = this.get_error
      return function (error_key) {
        if (get_func(error_key)) {
          return true
        }
        return false
      }
    },
    get_error_msg: function () {
      const chk_func = this.chk_error
      const get_func = this.get_error
      return function (error_key) {
        if (chk_func(error_key)) {
          return get_func(error_key)
        }
        return ''
      }
    },
    license_filter_sort: function () {
      const owner_license = this.owner_obj.owner_license
      return function (license_class) {
        if (typeof owner_license === 'object') {
          return owner_license.filter(
            license =>
              parseInt(license.license_class) == parseInt(license_class)
          )
        }
        return false
      }
    },

    get_owner_license_filter_year: function () {
      const owner_license = this.owner_obj.owner_license
      return function (year) {
        if (typeof owner_license === 'object') {
          return owner_license.filter(
            license => parseInt(license.license_year) == parseInt(year)
          )
        }
        return false
      }
    },
    get_owner_license_filter_year_class: function () {
      const get_func = this.get_owner_license_filter_year
      return function (year, class_cd) {
        const get_data = get_func(year)
        if (typeof get_data === 'object') {
          return get_data.filter(
            license => parseInt(license.license_class) == parseInt(class_cd)
          )
        }
        return false
      }
    },
    chk_owner_license_filter_year_class_only_term: function () {
      const get_func = this.get_owner_license_filter_year_class
      const get_func2 = this.get_owner_license_filter_year_class_term
      return function (year, class_cd, term_cd) {
        const get_data = get_func(year, class_cd)
        const get_data2 = get_func2(year, class_cd, term_cd)
        if (
          typeof get_data === 'object' &&
          typeof get_data2 === 'object' &&
          get_data.length > 0 &&
          get_data2.length > 0 &&
          get_data.length == get_data2.length
        ) {
          return true
        }
        return false
      }
    },
    get_owner_license_filter_year_class_term: function () {
      const get_func = this.get_owner_license_filter_year_class
      return function (year, class_cd, term_cd) {
        const get_data = get_func(year, class_cd)
        if (typeof get_data === 'object') {
          return get_data.filter(
            license => parseInt(license.license_term_cd) == parseInt(term_cd)
          )
        }
        return false
      }
    },
    get_owner_license_filter_year_class_terms: function () {
      const get_func = this.get_owner_license_filter_year_class
      return function (year, class_cd, term_cd_list) {
        const get_data = get_func(year, class_cd)
        if (typeof get_data === 'object') {
          return get_data.filter(license =>
            term_cd_list.includes(parseInt(license.license_term_cd))
          )
        }
        return false
      }
    },
    license_year_list: function () {
      const tmps = []
      for (let y = common.getNowYear() - 5; y <= common.getNowYear(); y++) {
        tmps.push({
          key: y,
          label: y + '年'
        })
      }

      return tmps.sort((a, b) => {
        if (parseInt(a.key) > parseInt(b.key)) {
          return -1
        } else {
          return 1
        }
      })
    },
    get_list_param: function () {
      const get_func_list = {
        event: this.get_event_data,
        license: this.get_license_data,
        license_class: this.get_class_data,
        license_category: this.get_category_data,
        affiliation_type: this.get_affiliation_type
      }
      return function (key, code, param) {
        const get_data = get_func_list[key](code)
        if (
          typeof get_data === 'object' &&
          (typeof get_data[param] === 'string' ||
            typeof get_data[param] === 'number')
        ) {
          return get_data[param]
        }
        return code
      }
    },
    get_affiliation_type: function () {
      const affiliation_type_list = this.affiliation_type_list
      return function (affiliation_cd) {
        return affiliation_type_list.find(
          affiliation => affiliation.key == affiliation_cd
        )
      }
    },
    get_event_data: function () {
      const event_cd_list = this.event_cd_list
      return function (event_cd) {
        return event_cd_list.find(event => event.event_cd == event_cd)
      }
    },
    get_license_data: function () {
      const license_cd_list = this.license_cd_list
      return function (license_cd) {
        return license_cd_list.find(license => license.license_cd == license_cd)
      }
    },
    get_class_data: function () {
      const class_list = this.license_class_list
      return function (class_cd) {
        return class_list.find(cls => cls.key == class_cd)
      }
    },
    get_category_data: function () {
      const category_list = this.license_category_list
      return function (category_cd) {
        return category_list.find(cate => cate.key == category_cd)
      }
    },
    event_cd_list: function () {
      const lists = [...this.event_cd_obj]
      return lists
        .map(list => {
          list.key = list.event_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list: function () {
      const lists = [...this.license_cd_obj]
      return lists
        .map(list => {
          list.key = list.license_cd
          // list.class_label = this.get_list_param('license_class', list.license_class, 'label');
          // list.category_label = this.get_category_label('license_category', list.license_category, 'label');
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    },

    district_cd_list: function () {
      const lists = [...this.district_obj]
      return lists
        .map(list => {
          list.key = list.district_cd
          // list.label = '(' + list.label + ')';
          // if(
          //   list.pref_cd_label != list.label
          // ){
          //   list.label += (list.pref_cd_label + '(' + list.label + ')');
          // }
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    pref_cd_list: function () {
      const lists = [...this.pref_obj]
      return lists
        .map(list => {
          list.key = list.pref_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    region_cd_list: function () {
      const lists = [...this.region_obj]
      return lists
        .map(list => {
          list.key = list.region_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    pref_filter: function () {
      const pref_cd_list = this.pref_cd_list
      return function (region_key) {
        return pref_cd_list.filter(pref => pref.region_cd == region_key)
      }
    },
    pref_list: function () {
      const lists = [...this.pref_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    group_list: function () {
      return []
    },
    insurance_type_list: function () {
      const lists = [...this.insurance_type_obj]
      return lists
    },
    belong_owner_status_list: function () {
      const lists = [...this.belong_owner_status_obj]
      return lists
    },
    affiliation_type_list: function () {
      const lists = [...this.affiliation_type_obj]
      return lists
    },
    continue_app_type_list: function () {
      return this.continue_app_type_obj
    },
    continue_data_save_type_list: function () {
      return this.continue_data_save_type_obj
    },
    request_type_list: function () {
      return this.request_type_cd_obj
    },
    identify_type_list: function () {
      return this.identify_type_cd_obj
    },
    exclude_list: function () {
      return this.exclude_cd_obj
    },
    dead_or_live_list: function () {
      return this.dead_or_live_obj
    },
    owner_assets_list: function () {
      return this.owner_assets_cd_obj
    },
    owner_document_list: function () {
      return this.owner_document_cd_obj
    },
    complete_type_list: function () {
      return this.complete_type_obj
    },
    race_owner_type_cd_list: function () {
      const tmps = []
      if (Array.isArray(this.race_owner_type_cd_obj)) {
        this.race_owner_type_cd_obj.forEach(obj => {
          tmps.push({
            key: obj.id,
            label: obj.label
          })
        })
      }
      return tmps
      // return this.race_owner_type_cd_obj
    },
    race_owner_type_grade_list: function () {
      return this.race_owner_type_grade_obj
    },

    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    tabDisplay: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'd-none '
        if (self_tab_active == tab) {
          tabClass = 'd-block'
        }
        return tabClass
      }
    },
    tab_switch: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'nav-link '
        // console.log('tab_switch', self_tab_active);
        if (self_tab_active == tab) {
          tabClass += 'active'
        }
        return tabClass
      }
    },
    circuit_list: function () {
      const lists = [...this.circuit_obj]
      return lists
        .map(list => {
          list.key = list.id
          // list.class_label = this.get_list_param('license_class', list.license_class, 'label');
          // list.category_label = this.get_category_label('license_category', list.license_category, 'label');
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    get_clinic_data: function () {
      const clinic_list = this.clinic_list
      return function (clinic_id) {
        return clinic_list.find(clinic => {
          return clinic.id == clinic_id
        })
      }
    },
    get_clinic_label: function () {
      const get_clinic_data = this.get_clinic_data
      return function (clinic_id) {
        return get_clinic_data(clinic_id).label
      }
    }
  },

  async created() {
    await this.loadTermYear()
    await this.loadLicenseCdList()
    await this.loadEventCdList()
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseTypeObj()
    await this.loadDistrictList()
    await this.loadPrefList()
    await this.loadRegionList()
    await this.loadSexType()
    await this.loadCircuitList()
    await this.loadConfigObj('affiliation_type')
    await this.loadConfigObj('insurance_type')
    await this.loadConfigObj('belong_owner_status')
    await this.loadConfigObj('continue_app_type')
    await this.loadConfigObj('continue_data_save_type')
    await this.loadConfigObj('request_type_cd')
    await this.loadConfigObj('identify_type_cd')
    await this.loadConfigObj('exclude_cd')
    await this.loadConfigObj('dead_or_live')
    await this.loadConfigObj('owner_assets_cd')
    await this.loadConfigObj('owner_document_cd')
    await this.loadConfigObj('license_term_cd')
    await this.loadRaceOwnerTypeCdList()
    await this.loadConfigObj('race_owner_type_grace')
    await this.loadConfigObj('complete_type')

    await this.loadNextOwnerNo()

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadOwnerObj()
      this.btnLabel = '更新'
    } else {
      this.owner_obj = Object.assign({
        id: 0,
        stat: 1,
        owner_no: this.default_owner_no,
        name_1: '',
        name_2: '',
        name_3: '',
        yomi_1: '',
        yomi_2: '',
        yomi_3: '',
        login_id: '',
        default_pass: this.default_pass_random,
        login_pass: this.default_pass_random,
        birth_date: '',
        sex_type: 'unanswered',
        license_no: '',
        live_flg: 'live',
        live_flg_now: 'live',
        identify_type: '',
        identify_manage_id: '',
        identify_date: '',
        continue_app_type: 0,
        continue_data_save_type: 0,
        application_date: '',
        permission_date: '',
        permission_manage_id: '',
        payment_date: '',
        identify_sw: false,
        identify_manage_label: '',
        permission_sw: false,
        permission_manage_label: '',
        identify_date_date: '',
        application_date_date: '',
        permission_date_date: '',
        payment_date_date: '',
        profile: [],
        // insurance: [],
        // circuit_license: [],
        // belong_owner: [],
        system_exclude: [],
        // owner_parent: [],
        owner_note: [],
        owner_assets: [],
        // owner_license: [],
        event_relation: []
      })
      this.btnLabel = '登録'

      // set
      // this.owner_obj.profile.push({...this.profile_column});
      // this.owner_obj.insurance.push({...this.insurance_column});
      this.oParam.forEach(param => {
        const param_key = param + '_column'
        if (this.owner_obj[param] === false) {
          this.owner_obj[param] = []
          this.owner_error_obj[param] = []
        }
        if (typeof this.owner_obj[param] !== 'object') {
          this.owner_obj[param] = []
          this.owner_error_obj[param] = []
        }
        if (
          typeof this.owner_obj[param] !== 'object' ||
          (typeof this.owner_obj[param] === 'object' &&
            this.owner_obj[param].length <= 0)
        ) {
          this.owner_obj[param].push({ ...this[param_key] })
        }
      })
    }
    this.alertMessage = this.btnLabel + 'できます'
    if (!this.not_add) {
      this.change_mode = false
    }
    this.$forceUpdate()
  },
  mounted: function () {
    this.fromParentTitle = '主催者データ'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
